import { EVENT_CONFIG } from "@/config/eventConfig";
import { SectionHeading, Reveal, GoldButton, useDonate } from "./shared";

const Children = () => {
  const { openDonate } = useDonate();
  const { images } = EVENT_CONFIG;

  const photos = [
    { src: images.childSmile, alt: "Child smiling with confidence" },
    { src: images.s4kHairshow, alt: "Styles 4 Kidz kids shining on stage at the annual hair show" },
    { src: images.s4kFamily, alt: "A Styles 4 Kidz family — love builds crowns" },
  ];

  return (
    <section id="children" data-testid="children-section" className="relative py-24 sm:py-32 bg-gradient-to-b from-ink via-oxblood/60 to-ink grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-14">
        <SectionHeading
          chapter="03"
          eyebrow="The Crown"
          title={
            <>
              EVERY CHILD DESERVES TO FEEL
              <br />
              <span className="gold-shimmer">CONFIDENT IN THEIR CROWN.</span>
            </>
          }
          sub="When a child's hair is cared for with knowledge and love, something shifts — shoulders back, chin up, crown on. Joy becomes pride. Pride becomes belonging."
        />

        <div className="grid sm:grid-cols-3 gap-4 sm:gap-6 w-full">
          {photos.map((p, i) => (
            <Reveal key={p.src} delay={i * 0.1} className={i === 1 ? "sm:-mt-8" : ""}>
              <div
                className={`group overflow-hidden gold-stroke spotlight-card ${
                  i === 1 ? "rounded-2xl" : "rounded-t-[10rem] rounded-b-2xl"
                }`}
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-80 sm:h-[26rem] object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="text-center">
          <p className="font-script text-3xl sm:text-5xl text-champagne leading-snug">
            Every crown cared for. Every child confident.
          </p>
          <div className="mt-8">
            <GoldButton testid="children-give-button" onClick={() => openDonate()}>
              Build a Crown
            </GoldButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Children;
